export default __webpack_public_path__ + "static/media/tk-a.e2ffb034.png";